import { render } from "./Video.vue?vue&type=template&id=3580b357&scoped=true"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"

import "./Video.vue?vue&type=style&index=0&id=3580b357&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3580b357"

export default script